import { Directive } from '@angular/core';
import { InputFilterBaseDirective } from './input-filter.base.directive';


@Directive({ selector: 'input[pinDigitsOnly]' })
export class DigitsOnlyDirective extends InputFilterBaseDirective {
  protected allowedKeyRegex = /^[0-9]$/;
  protected filterRegex = /\D/g; // Remove all non-digit characters
}
